/**
 * Resources: quick links to the external tools each department uses (prototype v108 §7). Admin sees every approved
 * resource; the other roles see their own. Links open in a new tab, at each tool's signed-in app (not its marketing
 * site), so staff land in the team's own account.
 */
export const RESOURCES = [
  { key: 'ghl', name: 'GoHighLevel', desc: 'CRM, client and talent communications, sales workflows, and automations.', href: 'https://app.gohighlevel.com' },
  { key: 'qbo', name: 'QuickBooks Online', desc: 'Accounting, reconciliation, vendor records, and financial operations.', href: 'https://qbo.intuit.com' },
  { key: 'slack', name: 'Slack', desc: 'Internal team communication and department coordination.', href: 'https://app.slack.com' },
  { key: 'stripe', name: 'Stripe', desc: 'Payment processing, transactions, refunds, and payment troubleshooting.', href: 'https://dashboard.stripe.com' },
  { key: 'aftershoot', name: 'Aftershoot', desc: 'Post-production culling and editing workflow.', href: 'https://aftershoot.com' },
  { key: 'box', name: 'Box', desc: 'Media storage, file delivery, and shared operational folders.', href: 'https://app.box.com' },
  { key: 'indeed', name: 'Indeed', desc: 'Talent recruiting and applicant sourcing.', href: 'https://employers.indeed.com' },
  // Traci's doc, Oct 2026: the live Google Doc instead of a PDF copy, because it changes often. Who can open it is set
  // by the doc's own sharing in Google.
  { key: 'sales_playbook', name: 'Sales Playbook', desc: 'Prices, add-ons and how we sell them (the live Google Doc).', href: 'https://docs.google.com/document/d/11szodA0At4OyJqWvkRAfEOHurn7LeSiFJWb90_CptDY/edit?usp=sharing' }
]

/** Which resources each role sees, in the prototype's order. */
export const RESOURCES_BY_ROLE = {
  admin: ['ghl', 'qbo', 'slack', 'stripe', 'aftershoot', 'box', 'indeed', 'sales_playbook'],
  billing: ['ghl', 'qbo', 'slack', 'stripe'],
  sales: ['sales_playbook', 'ghl', 'slack'],
  editing: ['aftershoot', 'box', 'ghl', 'slack'],
  talent_coordinator: ['ghl', 'box', 'indeed', 'slack']
}

const ROLE_LABEL = { admin: 'Admin', billing: 'Billing', sales: 'Sales', editing: 'Editing', talent_coordinator: 'Talent' }

export function resourcesFor(role) {
  const keys = RESOURCES_BY_ROLE[role] || []
  return keys.map(k => RESOURCES.find(r => r.key === k)).filter(Boolean)
}

/** The line under the title: Admin sees everything; everyone else sees their department's. */
export function resourcesNote(role) {
  return role === 'admin' ? 'Admin view includes all approved external resources.' : `${ROLE_LABEL[role] || 'Your'} resources only.`
}

/** The role label on a card: which departments use it. */
export function resourceRoles(key) {
  return Object.entries(RESOURCES_BY_ROLE).filter(([role, keys]) => role !== 'admin' && keys.includes(key)).map(([role]) => ROLE_LABEL[role])
}
